/*
A/B Header Test encapsulated for Adobe Target

Copy/paste everything in browser console to test.
When using Adobe Target, remember to add <script> tags at the beginning and end.

1) RE-BUILD FSI HEADER BANNER (gradient top bar)
2) CURRENT MEGANAV VISIBILITY
3) BUILD NAVIGATION
4) MEGA NAV LOGIC
5) LOAD DEPENDING ON SCREEN SIZES

CLEANED VERSION - Removed ~300+ lines of redundant positioning code
All positioning now handled by MegaMenuController
*/

(function() {
    'use strict';

    const isUS = document.querySelector("#main-nav-header").getAttribute("data-locale") === "en_US";
    const aemContainer = document.querySelector("main.container");
    const aemContainerMargin = 170;
    const hero = document.querySelector('#fs-cq-hro');
    const heroMargin = 45;
    const aemBreadcrumb = document.querySelector('nav.cmp-breadcrumb');
    const hasBreadcrumb = aemBreadcrumb && aemBreadcrumb.children.length > 0;
    let currentChosenTab;
    const estores = {
        "scientific": "Fisher Scientific",
        "healthcare": "Fisher Healthcare",
        "scied": "Fisher Education"
    };
    const siteCat = document.querySelector("header").getAttribute("data-estore");
    const estoreTranslation = estores[siteCat];
    const fisherSci = '<a href="/us/en/home.html" data-true-url="/us/en/home.html" class="kmd-text-white-0"  data-estore-cookie-banner="estore-scientific" data-analytics-section="Horizontal Nav - Top Banner" data-analytics-parent="E-store Link" data-analytics-container="Fisher Scientific" data-analytics-text="Fisher Scientific">Fisher Scientific</a>';
    const fisherHealthcare = '<a href="/us/en/healthcare-products.html" data-true-url="/us/en/healthcare-products.html" class="kmd-text-white-0" data-estore-cookie-banner="estore-healthcare" data-analytics-section="Horizontal Nav - Top Banner" data-analytics-parent="E-store Link" data-analytics-container="Fisher Healthcare" data-analytics-text="Fisher Healthcare">Fisher Healthcare</a>';
    const fisherSciEd = '<a href="/us/en/education-products.html" data-true-url="/us/en/education-products.html" class="kmd-text-white-0" data-estore-cookie-banner="estore-scied" data-analytics-section="Horizontal Nav - Top Banner" data-analytics-parent="E-store Link" data-analytics-container="Fisher Science Education" data-analytics-text="Fisher Science Education">Fisher Science Education</a>';
    let topBarLinks;
    let linksAdded = false;

    function isB2BUser() {
        try {
            var host = (window.location && window.location.hostname) ? window.location.hostname.toLowerCase() : '';
            return host.indexOf('punchout.fishersci') !== -1;
        } catch (e) {
            return false;
        }
    }

// 1) RE-BUILD FSI HEADER BANNER (gradient top bar)
    function setEstoreLinks() {
        if(linksAdded) return;
        if (siteCat === "scientific") {
            topBarLinks = fisherHealthcare + fisherSciEd;
        } else if (siteCat === "healthcare") {
            topBarLinks = fisherSci + fisherSciEd;
        } else if (siteCat === "scied") {
            topBarLinks = fisherSci + fisherHealthcare;
        } else {
            topBarLinks = fisherSci + fisherHealthcare + fisherSciEd;
        }
        if(isUS) {
            if (!document.querySelector("#fs-headerfooter-hbr")) {
                document.querySelector(".user_name").insertAdjacentHTML("afterend", '<div id="fs-headerfooter-hbr" class="fallback-banner kmd-text-sml dynamic-offer desktop-banner fsi-header-banner kmd-d-justify-center kmd-d-flex kmd-d-align-center kmd-banner__gradiant">' + topBarLinks + '</div>');
                document.querySelector("header").classList.add("banner-transition");

                const headerShim = document.querySelector("#header-shim");
                const dummyElement = document.createElement('span');
                headerShim.classList.remove("banner-disabled");
                headerShim.classList.add("banner-enabled");
                if (bannerDiv) {
                    bannerDiv.appendChild(dummyElement);
                }
            } else {
                const topBar = document.querySelector("#fs-headerfooter-hbr");
                topBar.classList.add("kmd-d-flex", "dynamic-offer", "desktop-banner", "kmd-d-justify-spacebetween", "kmd-d-align-center");

                const topBarContainer = document.createElement("div");
                topBarContainer.className = "fs-headerfooter-cont kmd-d-flex kmd-d-align-center";
                topBarContainer.innerHTML = '\n    <div id="fsi-header-col-1" class="fsi-header-banner kmd-text-weight-500">\n          ' + topBarLinks + '\n    </div>\n';
                topBar.appendChild(topBarContainer);

                const topBarCol2 = document.createElement("div");
                topBarContainer.appendChild(topBarCol2);
                topBarCol2.setAttribute("id", "fsi-header-col-2");

                const topBarHeaderBanner = document.querySelector(".fsi-header-banner");
                if (topBarHeaderBanner) {
                    topBarCol2.appendChild(topBarHeaderBanner);
                }

                topBar.classList.add("kmd-banner__gradiant");

                try {
                    topBarCol2.querySelector("a").classList.remove("fsi-header-banner", "kmd-banner__gradiant");
                    topBarCol2.querySelector("a").classList.add("kmd-text-white-0");
                    topBarCol2.querySelector("a > div").removeAttribute("style");
                    topBarCol2.querySelector("a > div > div").classList.remove("kmd-py-1", "kmd-px-4", "kmd-px-lg-8");
                    topBarCol2.querySelector("a > div > div").classList.add("kmd-pl-4", "kmd-pl-lg-8");
                    topBarCol2.querySelector("a > div > div > div").classList.remove("kmd-text-sml");
                    topBarCol2.querySelector("a > div > div > div > div:nth-child(2)").classList.add("kmd-d-align-items");
                    topBarCol2.querySelector("svg").style.marginTop = "-4px";
                } catch (e) {
                    console.error(e);
                }
            }

            //make sure spacing is correct
            const links = document.querySelectorAll("#fsi-header-col-1 a");

            if (links[0]) {
                links[0].classList.add("kmd-mr-sm-2");
                links[0].classList.remove("kmd-mx-sm-2");
            }

            if (links[1]) {
                links[1].classList.add("kmd-mx-sm-2");
                links[1].classList.remove("kmd-mr-sm-2");
            }

            // Estore listener
            const estoreElements = document.querySelectorAll('[data-estore-cookie-banner]');
            if (estoreElements) {
                estoreElements.forEach(function(element) {
                    element.addEventListener('click', function() {
                        const estoreCookie = this.getAttribute('data-estore-cookie-banner');

                        if (estoreCookie) {
                            const cookieOptions = {
                                expires: new Date(Date.now() + 180 * 24 * 60 * 60 * 1000),
                                path: '/',
                                sameSite: 'None',
                                secure: true
                            };

                            window.utils.setCookie('estore', estoreCookie, cookieOptions);
                            console.log('Estore cookie set to:', estoreCookie);
                        }
                    });
                });
            }

            linksAdded = true;
        }
    }


    function switchToAltHeader() {



        let mainContent = document.querySelector(".main");

        //adjust AEM containers margin
        if(aemContainer){
            if(hero) {
                hero.style.marginTop = `${heroMargin}px`;
            } else {
                if(!hasBreadcrumb){
                    aemContainer.style.setProperty("margin-top", `${aemContainerMargin}px`, "important");
                }
            }
        }



        // 1.2 If top bar doesn't exist, create new one with just estore links ONLY FOR US


        // 2) CURRENT MEGANAV VISIBILITY
        function hideDrawer(state) {
            const drawerNav = document.querySelector("#open-main-drawer");
            const drawerContent = document.querySelector(".drawer");

            if(!drawerNav || !drawerContent) return;

            if (state === "show") {
                drawerNav.classList.remove('hide');
                drawerNav.style.display = "block";
            } else if (state === "hide") {
                drawerNav.classList.add('hide');
                drawerNav.style.display = "none";
                drawerContent.style.display = "none";
                drawerContent.ariaHidden = "true";
            }
        }

        // 3) BUILD NAVIGATION

        function buildNav() {
            const mN = document.querySelector("#main-nav-header");
            const nav = document.createElement("nav");
            nav.className = "navigation container-shadow";
            nav.setAttribute("id", "main-horizontal-nav");
            nav.setAttribute("aria-label", "Site navigation");

            const arrowSVG = `
      <span class="dropdown-arrow">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 319 511.61">
          <path d="M48.92 505.72 5.88 462.68c-7.85-7.85-7.83-20.72 0-28.54l178.35-178.35L5.88 77.44c-7.85-7.85-7.8-20.73 0-28.54L48.92 5.87c7.83-7.82 20.71-7.82 28.54 0l192.25 192.26.37.36 43.04 43.03c7.82 7.84 7.86 20.69 0 28.54l-43.04 43.04-.37.36L77.46 505.72c-7.85 7.86-20.68 7.86-28.54 0z"/>
        </svg>
      </span>`;

            const navItemsHTML = Object.keys(navigationData)
                .sort((a, b) => Number(a) - Number(b))
                .map((key) => {
                    const label = (navigationData[key] && navigationData[key].parentLabel) || "";
                    let href = "#";
                    let hasPopup = true;
                    let arrow = arrowSVG;
                    let linkOnly = navigationData[key] && navigationData[key].linkOnly ? 'data-linkonly="true"' : '';
                    let cssClass = navigationData[key] && navigationData[key].cssClass ? navigationData[key].cssClass : '';

                    if (!label) return "";

                    if(linkOnly !== ''){
                        href = (navigationData[key] && navigationData[key].href) || "#";
                        hasPopup = false;
                        arrow = '';
                    }

                    return `
              <div class="nav-item">
              <a href="${href}"
                 class="nav-link ${cssClass}"
                 ${!linkOnly ? `
                   role="menuitem"
                   aria-haspopup="${hasPopup}"
                   aria-expanded="false"
                 ` : ""}
                 ${linkOnly}
                 data-nav-key="${key}">
                ${label}
                ${arrow}
              </a>
            </div>`;
                })
                .join("");

            nav.innerHTML = `<div class="nav-content">${navItemsHTML}</div>`;

            if(mN){
                mN.parentNode.insertBefore(nav, mN.nextSibling);
            }

            // create mega dropdown
            const megaDrop = document.createElement("div");
            megaDrop.className = "mega-dropdown";
            megaDrop.setAttribute("id", "universalDropdown");
            megaDrop.innerHTML = `
      <div class="mega-dropdown-content">
        <div class="mega-dropdown-sidebar" id="dropdownSidebar"></div>
        <div class="mega-dropdown-main" id="dropdownMain"></div>
      </div>`;
            nav.parentNode.insertBefore(megaDrop, nav.nextSibling);

            window.addEventListener('scroll', () => {
                if (window.scrollY > 30) {
                    nav.classList.add('hidden');
                } else {
                    nav.classList.remove('hidden');
                }
            });
        }

        // 4) MEGA NAV LOGIC

        function navLogic() {
            const universalDropdown = document.getElementById("universalDropdown");
            const dropdownSidebar = document.getElementById("dropdownSidebar");
            const dropdownMain = document.getElementById("dropdownMain");
            const dropdownContent = document.querySelector(".mega-dropdown-content");
            const navigationBar = document.querySelector(".navigation");

            let currentActiveIndex = -1;
            let isPDP = false;

            const bodyID = document.querySelector("body").getAttribute("id");
            if (bodyID === "SinglePDP" || bodyID === "productDisplay" || bodyID === "itemDisplay") {
                isPDP = true;
                mainContent = document.querySelector(".main");
            } else if (document.querySelector("main")) {
                mainContent = document.querySelector("main");
            } else if (document.querySelector(".main-cart-section")) {
                mainContent = document.querySelector("#main");
            }

            // Certain pages skip fixed nav
            function skipFixedNav(){
                const skipPages = ['/store1/mylist', '/store1/order-approval/requisitions',
                    '/store1/quotes', '/store1/account-dashboard', '/store1/subscriptionorders/'];
                return skipPages.some(page => window.location.pathname.includes(page));
            }

            function addOverlay() {
                if (document.querySelector(".main-nav-header-overlay")) return;

                universalDropdown.insertAdjacentHTML("beforebegin", '<div class="main-nav-header-overlay"></div>');
                if(!skipFixedNav()) {
                    navigationBar.classList.add('fixednav');
                }
                document.body.classList.add('no-scroll');

                if(mainContent) {
                    mainContent.classList.add('fixedcontent');
                    if (isPDP) {
                        mainContent.style.display = "block !important";
                        mainContent.style.margin = "0 auto !important";
                        mainContent.style.maxWidth = "none !important";
                    }
                }
            }

            function removeOverlay() {
                const overlay = document.querySelector(".main-nav-header-overlay");
                if (!overlay) return;

                overlay.remove();
                navigationBar.classList.remove('fixednav');
                document.body.classList.remove('no-scroll');

                if(mainContent) {
                    mainContent.classList.remove('fixedcontent');
                    if (isPDP) {
                        mainContent.removeAttribute("style");
                    }
                }
            }

            function closeUniversalDropdown() {
                universalDropdown.classList.remove("active");
                document.querySelectorAll(".nav-item").forEach((item) => item.classList.remove("active"));
                removeOverlay();
                currentActiveIndex = -1;

                const dropdownLinks = universalDropdown.querySelectorAll("button");
                dropdownLinks.forEach((link) => {
                    link.setAttribute("tabindex", "-1");
                });
            }

            function openUniversalDropdown(index) {
                const navItems = document.querySelectorAll(".nav-item");

                navItems.forEach((navItem) => {
                    navItem.querySelector("a").setAttribute("aria-expanded", "false");
                    navItem.classList.remove("active");
                });

                navItems[index].classList.add("active");
                navItems[index].querySelector("a").setAttribute("aria-expanded", "true");
                currentActiveIndex = index;

                populateDropdown(index);

                universalDropdown.classList.add("mega-menu-measuring");
                universalDropdown.classList.add("active");
                addOverlay();

                void universalDropdown.offsetHeight; // Force reflow

                // Position the menu using MegaMenuController
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        if (window.MegaMenuController && MegaMenuController.reposition) {
                            MegaMenuController.reposition();
                        }

                        requestAnimationFrame(() => {
                            universalDropdown.classList.remove("mega-menu-measuring");

                            const dropdownLinks = universalDropdown.querySelectorAll("button");
                            dropdownLinks.forEach((link) => link.setAttribute("tabindex", "0"));

                            setTimeout(() => {
                                const firstTabbable = universalDropdown.querySelector("a, button");
                                if (firstTabbable) firstTabbable.focus();
                            }, 50);
                        });
                    });
                });
            }

            function populateDropdown(index) {
                const data = navigationData[index];
                if (!data || data.linkOnly) return;

                // Populate sidebar
                dropdownSidebar.innerHTML = "";
                if(data.sidebar && !data.sidebar[0].hideSidebar) {
                    data.sidebar.forEach((item, idx) => {
                        const link = document.createElement("a");
                        const linkParent = data.parentLabel ? data.parentLabel : '';
                        link.href = "#";
                        link.className = 'sidebar-item ' + (item.active ? "active" : "");
                        link.setAttribute("data-target", item.id);
                        link.setAttribute("role", "menuitem");
                        link.setAttribute("aria-haspopup", "true");
                        link.setAttribute("aria-expanded", "false");
                        link.setAttribute('data-analytics-section', 'Horizontal Nav');
                        link.setAttribute('data-analytics-parent', linkParent);
                        link.setAttribute('data-analytics-container', estoreTranslation);
                        link.setAttribute('data-analytics-text', item.label + '|' + (idx + 1));
                        link.textContent = item.label;
                        dropdownSidebar.classList.remove('hide');
                        dropdownContent.classList.remove('no-sidebar');
                        dropdownSidebar.appendChild(link);
                    });
                }

                if(data.sidebar && data.sidebar[0].hideSidebar) {
                    dropdownSidebar.classList.add('hide');
                    dropdownContent.classList.add('no-sidebar');
                }

                if(data.cssClassForContent){
                    dropdownContent.classList.add(...data.cssClassForContent.split(" "));
                }

                // Add footer if exists
                if (data.footer) {
                    const footerDiv = document.createElement("div");
                    footerDiv.className = "dropdown-footer";
                    data.footer.forEach((linkData, i) => {
                        // Skip footer link for B2B users if explicitly flagged
                        if (linkData && typeof linkData === 'object' && linkData.hasOwnProperty('showForB2B')) {
                            if (linkData.showForB2B === false && isB2BUser()) {
                                return; // skip this footer link
                            }
                        }

                        const link = document.createElement("a");
                        let footerHref = linkData.useLocale && linkData.href ? localeUrlPath + linkData.href : linkData.href;
                        link.href = footerHref || "#";
                        link.textContent = linkData.text;
                        link.setAttribute('data-analytics-section', 'Horizontal Nav');
                        link.setAttribute('data-analytics-parent', '');
                        link.setAttribute('data-analytics-container', estoreTranslation + '|' + data.parentLabel);
                        link.setAttribute('data-analytics-text', linkData.text + '|' + (i + 1));
                        footerDiv.appendChild(link);
                    });
                    dropdownSidebar.appendChild(footerDiv);
                }

                // Populate main content
                const activeItem = data.sidebar.find(item => item.active);
                const activeId = activeItem && activeItem.id ? activeItem.id : data.sidebar[0].id;

                populateMainContent(data, activeId);

                // Add event listeners to sidebar items
                let hoverTimer = null;
                const HOVER_DELAY = 300;

                dropdownSidebar.querySelectorAll(".sidebar-item").forEach((item) => {
                    item.addEventListener("click", function(e) {
                        e.preventDefault();
                        clearTimeout(hoverTimer);
                        activateSidebarItem(this);
                    });

                    item.addEventListener("mouseenter", function() {
                        clearTimeout(hoverTimer);

                        if (this.classList.contains("active")) return;

                        hoverTimer = setTimeout(() => {
                            activateSidebarItem(this);
                        }, HOVER_DELAY);
                    });

                    item.addEventListener("mouseleave", function() {
                        clearTimeout(hoverTimer);
                    });

                    item.addEventListener("keydown", function(e) {
                        if (e.key === "Enter" || e.key === " " || e.key === "ArrowRight") {
                            e.preventDefault();
                            clearTimeout(hoverTimer);
                            activateSidebarItem(this);

                            setTimeout(() => {
                                const firstMainLink = dropdownMain.querySelector("a, button, .chemical-search-card, .special-offer-card");
                                if (firstMainLink) firstMainLink.focus();
                            }, 100);
                        }
                    });
                });
            }

            function activateSidebarItem(sidebarItem) {
                dropdownSidebar.querySelectorAll(".sidebar-item").forEach((item) => {
                    item.setAttribute("aria-expanded", "false");
                    item.classList.remove("active");
                });
                sidebarItem.classList.add("active");
                sidebarItem.setAttribute("aria-expanded", "true");

                const data = navigationData[currentActiveIndex];
                if (data) {
                    populateMainContent(data, sidebarItem.getAttribute("data-target"));

                    const newMainElements = dropdownMain.querySelectorAll("button");
                    newMainElements.forEach((element) => {
                        element.setAttribute("tabindex", "0");
                    });
                }
            }

            function populateMainContent(data, targetId) {
                const content = data.content[targetId];
                let dataAnalyticsContainer = estoreTranslation;
                let dataAnalyticsText = '';
                if(data.sidebar){
                    if(data.sidebar[0] && !data.sidebar[0].hideSidebar) {
                        dataAnalyticsContainer += `|${data.parentLabel}`;
                    }
                }
                if (!content) return;

                let h3Visibility = content.visible === false ? " kmd-d-none" : "";
                let shopOrBrowseAllText = content.titleId === "programs" || content.titleId === "services" ? browseAllText : shopAllText;

                let html = `
                <div class="mega-content-header${h3Visibility}">
                    <h3 class="mega-content-title" id="${content.titleId}">${content.title}</h3>
                    ${(content.shopAll||content.browseAll) ? `<a data-analytics-section="Horizontal Nav" data-analytics-container="${dataAnalyticsContainer}" data-analytics-parent="${content.title}" data-analytics-text="${shopOrBrowseAllText} ${content.title}" href="${(content.shopAllHref || content.browseAllHref) || '#'}" class="shop-all-link" tabindex="-1" aria-label="${shopOrBrowseAllText} ${content.title}">${shopOrBrowseAllText}</a>` : ""}
                </div>`;

                if (content.type === "text") {
                    html += `<p class="mega-content-description">${content.description}</p>`;
                } else if (content.type === "cards" && content.cards) {
                    html += '<div class="special-offers-grid">';
                    content.cards.forEach((card, index) => {
                        html += `
                        <a data-analytics-section="Horizontal Nav" data-analytics-container="${dataAnalyticsContainer}" data-analytics-parent="${content.title}" data-analytics-text="Special Offer ${card.title}|${index}" href="${card.href || "#"}" class="special-offer-card" tabindex="-1" style="text-decoration: none; color: inherit;">
                            <div class="special-offer-header" style="background-image:url('img/${card.image}.png');"></div>
                            <div class="special-offer-content">
                                <div class="special-offer-title">${card.title}</div>
                                <div class="special-offer-description">${card.description}</div>
                            </div>
                        </a>`;
                    });
                    html += "</div>";
                } else if (content.type === "grid" && content.columns) {
                    html += '<div class="mega-content-grid">';
                    content.columns.forEach((column) => {
                        //If the column has a title, adjust the data-analytics-text to include.
                        if(column.title){
                            dataAnalyticsText = `${column.title} `;
                        }
                        if (column.type === "card") {
                            html += `
                            <div class="mega-content-column">
                                <a data-analytics-parent="${content.title}" href="${column.href || "#"}" class="chemical-search-card" tabindex="-1">
                                    <img src="img/chemical-structure-search.png" alt="" role="decorative">
                                    <div class="chemical-search-title">${column.title}</div>
                                    <div class="chemical-search-description">${column.description}</div>
                                </a>
                            </div>`;
                        } else {
                            html += '<div class="mega-content-column">';
                            let hS = content.visible === false ? "h3" : "h4";
                            let sAL = column.shopAll ? `<a data-analytics-section="Horizontal Nav" data-analytics-parent="${column.title}" data-analytics-container="${dataAnalyticsContainer}" data-analytics-text="${shopOrBrowseAllText} ${column.title}" href="${column.shopAllHref || "#"}" class="shop-all-link" aria-label="${shopOrBrowseAllText} ${column.title}">${shopOrBrowseAllText}</a>` : "";

                            if (column.title) {
                                html += `<div class="title-shop-all"><${hS} id="${column.titleId}">${column.title}</${hS}>${sAL}</div>`;
                            }

                            if (column.links) {
                                html += "<ul>";
                                column.links.forEach((link, index) => {
                                    // Skip this link for B2B users if explicitly flagged
                                    if (link && typeof link === 'object' && link.hasOwnProperty('showForB2B')) {
                                        if (link.showForB2B === false && isB2BUser()) {
                                            return; // skip rendering this link
                                        }
                                    }
                                    if (typeof link === "object") {
                                        let linkRef = link.href && link.useLocale ? localeUrlPath + link.href : link.href;
                                        if (link.separator) {
                                            html += '<hr>';
                                        } else if (link.class) {
                                            html += `<li><a data-analytics-parent="${content.title}" data-analytics-section="Horizontal Nav" data-analytics-container="${dataAnalyticsContainer}" data-analytics-text="${dataAnalyticsText}${link.text}|${index + 1}" class="${link.class}" href="${linkRef || "#"}" role="menuitem">${link.text}</a></li>`;
                                        } else {
                                            html += `<li><a data-analytics-parent="${content.title}" data-analytics-section="Horizontal Nav" data-analytics-container="${dataAnalyticsContainer}" data-analytics-text="${dataAnalyticsText}${link.text}|${index + 1}" href="${linkRef || "#"}" role="menuitem">${link.text}</a></li>`;
                                        }
                                    } else {
                                        html += `<li><a data-analytics-parent="${column.title}" data-analytics-section="Horizontal Nav" data-analytics-container="${dataAnalyticsContainer}" data-analytics-text="${link}|${index + 1}" href="#">${link}</a></li>`;
                                    }
                                });
                                html += "</ul>";
                            }
                            html += "</div>";
                        }
                    });
                    html += "</div>";
                }

                dropdownMain.innerHTML = html;
            }

            // Desktop navigation with improved accessibility
            const navItems = document.querySelectorAll(".nav-item");

            navItems.forEach((item, index) => {
                const navLink = item.querySelector(".nav-link");

                // Handle click events
                item.addEventListener("click", function(e) {
                    if(e.target.hasAttribute('data-linkonly')) return;
                    e.preventDefault();

                    if (this.classList.contains("active") && currentActiveIndex === index) {
                        closeUniversalDropdown();
                        return;
                    }

                    currentChosenTab = this;
                    openUniversalDropdown(index);
                });

                // Handle keyboard events on nav links
                navLink.addEventListener("keydown", function (e) {
                    const isLinkOnly = e.target.hasAttribute("data-linkonly");

                    if (isLinkOnly) {
                        if (e.key === "ArrowDown") {
                            e.preventDefault();
                        }
                        return;
                    }

                    if (e.key === "Enter") {
                        e.preventDefault();

                        if (item.classList.contains("active") && currentActiveIndex === index) {
                            closeUniversalDropdown();
                            return;
                        }

                        openUniversalDropdown(index);

                        const firstTabbable = universalDropdown.querySelector("a, button");
                        if (firstTabbable) {
                            setTimeout(() => {
                                firstTabbable.focus();
                            }, 0);
                        }

                        return;
                    }

                    if (e.key === " " || e.key === "ArrowDown") {
                        e.preventDefault();

                        if (item.classList.contains("active") && currentActiveIndex === index) {
                            closeUniversalDropdown();
                            return;
                        }

                        openUniversalDropdown(index);

                        if (e.key === "ArrowDown") {
                            const firstTabbable = universalDropdown.querySelector("a, button");
                            if (firstTabbable) {
                                firstTabbable.focus();
                            }
                        }

                        return;
                    }

                    if (e.key === "Escape") {
                        e.preventDefault();
                        closeUniversalDropdown();
                    } else if (e.key === "ArrowRight" && navItems[index + 1]) {
                        navItems[index + 1].querySelector(".nav-link").focus();
                    } else if (e.key === "ArrowLeft" && navItems[index - 1]) {
                        navItems[index - 1].querySelector(".nav-link").focus();
                    }
                });
            });

            // Handle tab navigation within dropdown
            document.addEventListener("keydown", function() {
                if (!universalDropdown.classList.contains("active")) return;

                const activeNavItem = document.querySelector(".nav-item.active .nav-link");
                let activeSidebarItem = document.querySelector(".sidebar-item.active");
                const sidebarElements = dropdownSidebar.querySelectorAll('a, button, [tabindex="0"], .dropdown-footer a');
                const mainElements = dropdownMain.querySelectorAll('a, button, [tabindex="0"]');
                const firstMain = mainElements[0];
                let noSidebar = false;

                if(!activeSidebarItem){
                    activeSidebarItem = activeNavItem;
                    noSidebar = true;
                }

                if(sidebarElements){
                    sidebarElements.forEach((item, idx) => {
                        item.addEventListener("keydown", function(e) {
                            if (e.key === "ArrowDown" && sidebarElements[idx + 1]) {
                                sidebarElements[idx + 1].focus();
                            } else if (e.key === "ArrowDown" && !sidebarElements[idx + 1]) {
                                firstMain.focus();
                            } else if (e.key === "ArrowUp" && sidebarElements[idx - 1]) {
                                sidebarElements[idx - 1].focus();
                            } else if (e.key === "ArrowUp" && !sidebarElements[idx - 1]) {
                                e.preventDefault();
                                closeUniversalDropdown();
                                activeNavItem.focus();
                            } else if (e.shiftKey && e.key === "Tab" && !sidebarElements[idx - 1]) {
                                e.preventDefault();
                                closeUniversalDropdown();
                                activeNavItem.focus();
                            }
                        });
                    });
                }

                mainElements.forEach((item, idx) => {
                    item.addEventListener("keydown", function(e) {
                        if (e.key === "ArrowLeft") {
                            activeSidebarItem.focus();
                            if(noSidebar) closeUniversalDropdown();
                        } else if (e.key === "ArrowUp" && mainElements[idx - 1]) {
                            mainElements[idx - 1].focus();
                        } else if (e.key === "ArrowUp" && !mainElements[idx - 1]) {
                            e.preventDefault();
                            activeSidebarItem.focus();
                            if(noSidebar) closeUniversalDropdown();
                        } else if (e.shiftKey && e.key === "Tab" && mainElements[idx - 1]) {
                            e.preventDefault();
                            mainElements[idx - 1].focus();
                        } else if (e.shiftKey && e.key === "Tab" && !mainElements[idx - 1]) {
                            e.preventDefault();
                            activeSidebarItem.focus();
                            if(noSidebar) closeUniversalDropdown();
                        } else if (e.key === "ArrowDown" && mainElements[idx + 1]) {
                            mainElements[idx + 1].focus();
                        } else if (e.key === "ArrowDown" && !mainElements[idx + 1]) {
                            e.preventDefault();
                            closeUniversalDropdown();
                            activeNavItem.focus();
                        } else if (e.key === "Tab" && !mainElements[idx + 1]) {
                            e.preventDefault();
                            closeUniversalDropdown();
                            activeNavItem.focus();
                        }
                    });
                });
            });

            // Close dropdown when clicking outside
            document.addEventListener("click", function(e) {
                if (!e.target.closest(".navigation") && !e.target.closest(".mega-dropdown-content")) {
                    closeUniversalDropdown();
                }
            });

            // Close dropdown when clicking Quick Links or Search
            const quickLinks = document.querySelectorAll(".quick-links .link a");
            quickLinks.forEach((item) => {
                item.addEventListener("click", function() {
                    if (universalDropdown.classList.contains("active")) {
                        closeUniversalDropdown();
                    }
                });
            });

            const searchBox = document.querySelector("#searchbar__searchBox__input");
            if(searchBox){
                searchBox.addEventListener("focus", function() {
                    if (universalDropdown.classList.contains("active")) {
                        closeUniversalDropdown();
                    }
                });
            }

            // Escape key to close menus
            document.addEventListener("keydown", function(e) {
                if (e.key === "Escape" && universalDropdown.classList.contains("active")) {
                    closeUniversalDropdown();
                    const lastTabbableNavItem = document.querySelector(".nav-item.active .nav-link");
                    if (lastTabbableNavItem) lastTabbableNavItem.focus();
                }
            });

            // Shadow appearance on scroll
            window.addEventListener("scroll", function() {
                const header = document.querySelector("header");
                if (window.pageYOffset > 45) {
                    navigationBar.classList.remove("container-shadow");
                    header.classList.add("container-shadow");
                } else {
                    header.classList.remove("container-shadow");
                    navigationBar.classList.add("container-shadow");
                }
            });

            // PDP-specific sticky behavior
            if (isPDP) {
                function pDPNavBarBreakpoints() {
                    navigationBar.style.marginTop = window.innerWidth <= 1024 ? "0" : (document.querySelector('.banner-disabled') ? "10px" : "0");
                }
                pDPNavBarBreakpoints();
                window.addEventListener('resize', pDPNavBarBreakpoints);
            }

            if (bodyID === "SinglePDP") {
                const stickyCartObserver = new MutationObserver(() => {
                    let productSticky = document.querySelector(".sticky_cart_wrapper");
                    let defaultOffset = document.querySelector('.promo_price') || window.innerWidth <= 992 ? 220 : 177;

                    if (productSticky && window.innerWidth >= 992) {
                        stickyCartObserver.disconnect();
                    }
                });
                stickyCartObserver.observe(document.body, {
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }

            // Basic page adjustments
            if (document.querySelector("body").classList.contains("basicpage")) {
                if (document.querySelector("main")) {
                    const breadcrumb = document.querySelector(".breadcrumb");
                    if (breadcrumb) breadcrumb.style.marginTop = "46px";
                }

                const hero = document.querySelector(".m--hero-size-medium-responsive");
                if (hero) hero.style.marginTop = "46px";
            }

            if (bodyID === "fs") {
                if (document.querySelector(".main-cart-section")) {
                    document.querySelector("#main").style.marginTop = "0";
                }
            }

        } // end of navLogic function

        // 5) LOAD DEPENDING ON SCREEN SIZES

        function checkScreenSize() {
            const horizontalNav = document.querySelector("#main-horizontal-nav");

            if (window.innerWidth < 992) {
                hideDrawer("show");

                if(horizontalNav){
                    horizontalNav.classList.add("d-none");
                }

                if(aemContainer){
                    if(hero){
                        hero.style.marginTop = "0";
                    } else {
                        aemContainer.removeAttribute('style');
                    }
                }
            } else if (window.innerWidth >= 992) {
                if(horizontalNav){
                    horizontalNav.classList.remove("d-none");
                }
                if(aemContainer){
                    if(hero) {
                        hero.style.marginTop = `${heroMargin}px`;
                    } else {
                        if(!hasBreadcrumb){
                            aemContainer.style.setProperty("margin-top", `${aemContainerMargin}px`, "important");
                        }
                    }
                }
                hideDrawer("hide");
                if (!document.querySelector(".navigation")) {
                    buildNav();
                    navLogic();
                }
            }
        }

        function normalizeSpacing() {
            const isCart = !!document.querySelector('.main.cart-checkout-ui-main');
            const isPDP = !!document.querySelector('.breadcrumbs_wrap');
            const isConfigurator = !!document.querySelector('#configuratorContainer');

            if(isCart){
                const cartContainer = document.querySelector('.main.cart-checkout-ui-main');
                cartContainer.classList.add('p-top-10');
            }
            if(isPDP){
                if(document.querySelectorAll('core-breadcrumb').length == 0){
                    document.querySelector('.breadcrumbs_wrap').classList.add('m-top-24');
                }
            }
            if(isConfigurator){
                document.querySelector('#configuratorContainer').classList.add('m-top-24');
            }
        }

        checkScreenSize();
        normalizeSpacing();

        window.addEventListener('resize', checkScreenSize);

        // Add analytics
        const navLinks = document.querySelectorAll('.nav-item a');
        navLinks.forEach((link, index) => {
            const linkText = link.textContent.trim();
            link.setAttribute('data-analytics-section', 'Horizontal Nav');
            link.setAttribute('data-analytics-parent', '');
            link.setAttribute('data-analytics-container', estoreTranslation);
            link.setAttribute('data-analytics-text', linkText + '|' + (index + 1));
        });



    } // end of switchToAltHeader function

// --- Positioning controller (handles all dropdown positioning) ---
    window.MegaMenuController = (function () {
        const DESKTOP_MIN = 992;
        const EDGE_PAD = 8;
        const TAB_OFFSET = 0;
        let menuEl = null;
        let moNav = null;
        let ticking = false;
        let initialized = false;

        function isVisible(el) {
            if (!el) return false;
            const cs = getComputedStyle(el);
            if (cs.display === "none" || cs.visibility === "hidden") return false;
            const r = el.getBoundingClientRect();
            return r.width > 0 && r.height > 0;
        }

        function getActiveTab() {
            return document.querySelector("div.nav-item.active");
        }

        function positionNow() {
            if (!menuEl || window.innerWidth < DESKTOP_MIN) return;
            const activeTab = getActiveTab();
            if (!activeTab) return;

            // Clear any inline styles
            menuEl.style.left = "";
            menuEl.style.right = "";
            menuEl.style.marginLeft = "";
            menuEl.style.position = "fixed";

            const tabRect = activeTab.getBoundingClientRect();
            const menuRect = menuEl.getBoundingClientRect();
            const vw = window.innerWidth;

            let left = tabRect.left - TAB_OFFSET;

            // Flip if would overflow
            if (left + menuRect.width > vw - EDGE_PAD) {
                left = tabRect.right - menuRect.width;
            }

            // Clamp to viewport
            const minLeft = EDGE_PAD;
            const maxLeft = Math.max(EDGE_PAD, vw - menuRect.width - EDGE_PAD);
            left = Math.max(minLeft, Math.min(left, maxLeft));

            menuEl.style.left = Math.round(left) + "px";
        }

        function schedulePosition() {
            if (ticking) return;
            ticking = true;
            requestAnimationFrame(() => {
                positionNow();
                ticking = false;
            });
        }

        function handleResize() { schedulePosition(); }
        function handleScroll() { schedulePosition(); }

        function observeNavChanges() {
            const navRoot = document.querySelector("#fs > nav");
            if (!navRoot) return;
            moNav = new MutationObserver(() => {
                requestAnimationFrame(() => requestAnimationFrame(schedulePosition));
            });
            moNav.observe(navRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
        }

        return {
            init() {
                if (initialized) return;
                menuEl = document.querySelector(".mega-dropdown-content");
                if (!menuEl) return;
                initialized = true;

                window.addEventListener("resize", handleResize, { passive: true });
                window.addEventListener("scroll", handleScroll, { passive: true, capture: true });

                observeNavChanges();

                requestAnimationFrame(() => requestAnimationFrame(positionNow));
            },

            destroy() {
                initialized = false;
                window.removeEventListener("resize", handleResize);
                window.removeEventListener("scroll", handleScroll, { capture: true });
                if (moNav) { moNav.disconnect(); moNav = null; }
                if (menuEl) {
                    menuEl.style.left = "";
                    menuEl.style.right = "";
                    menuEl.style.marginLeft = "";
                }
                menuEl = null;
                ticking = false;
            },

            reposition() {
                if (!initialized) return;
                schedulePosition();
            }
        };
    })();

    function initWhenReady() {
        const observer = new MutationObserver(() => {
            const fmContent = document.querySelector('#fm-text');
            if (document.querySelector("header") &&
                document.querySelector('#mobileNav') &&
                document.querySelector("#fs-headerfooter-hbr") &&
                !document.querySelector(".fallback-banner") &&
                (document.querySelector(".fsi-header-banner") || fmContent.textContent.trim().length > 0) || document.querySelector(".banner-timed-out")) {

                observer.disconnect();

                //update the banner after loading
                setEstoreLinks();
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        setTimeout(() => observer.disconnect(), 5000);

        //Main init()
        switchToAltHeader();
        MegaMenuController.init();

        //For US only -
        document.addEventListener("bannerTimeout", () => {
            if(isUS){
                setEstoreLinks();
            }
        });


        document.addEventListener("bannerRemoved", () => {
            switchToAltHeader();
            const megaDropdown = document.querySelector(".mega-dropdown");
            if (megaDropdown && !isUS) {
                megaDropdown.classList.add("no-banner");
            }
            const hbr = document.querySelector('#fs-headerfooter-hbr');
            if(hbr){
                hbr.classList.remove("kmd-d-justify-center");
            }
            MegaMenuController.init();
        });
    }

    if(!env.isLiteHeader){
        initWhenReady();
    }

})(); // End IIFE
